function create(type, filterTranslator, opts) {
  const {
    filterType = 'Equals',
    not = false
  } = opts || {};
  return {
    id: `custom.${type}.${filterType}.ComparatorFilterConverter`,
    type: `${type}.${filterType}`,
    convert: (cmp, attribute) => {
      if (cmp.value1 == null) {
        return null;
      }
      return {
        type: 'logical',
        operator: 'or',
        not,
        conditions: cmp.value1?.reduce((prev, curr) => {
          if (filterTranslator[curr]) {
            prev.push(filterTranslator[curr]());
          }
          return prev;
        }, [])
      };
    }
  };
}
export default {
  create
};